export const STATE_NAME = 'FEATURE_FLAGS';
